import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AdminService } from '@app/services/admin/admin.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-admin-system-permissions-add',
  templateUrl: './admin-system-permissions-add.component.html'
})
export class AdminSystemPermissionsAddComponent implements OnInit {
  @Input() formdata;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  roles: SelectItem[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private adminService: AdminService) { }

  ngOnInit() {
  this.form = this.fb.group({
    id: [null, ''],
    memberId: ['', ''],
    roleId: ['', ''],
    roleDescription: ['', ''],
    note: ['', ''],
    emailForSystemMessages: ['', '']
  });
  
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    });
    this.getRoles();
  }

  saveSystemPermission() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }

  getRoles() {
    this.adminService.GetRoles().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          if (d.id === 12 || d.id === 13) {
            this.roles.push(record);
          }
        });

      }
    });
  }

  setRole(evt) {
    this.form.patchValue({ roleId: evt.value });
  }
}
